"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = require("styled-components");

var _linkBase = require("../../components/link/link-base");

var markdownStyles = (0, _styledComponents.css)([".gf_styled__markdown{h1,h2,h3,h4,h5,p,a,li{", "}h1{", "}h2{", "}h3{", "}h4{", "}h5{", "}p,li{", "}a{", " ", "}}"], function (props) {
  return props.theme.typography.baseCSS;
}, function (props) {
  return props.theme.typography.title;
}, function (props) {
  return props.theme.typography.heading;
}, function (props) {
  return props.theme.typography.subheading;
}, function (props) {
  return props.theme.typography.header4;
}, function (props) {
  return props.theme.typography.caption;
}, function (props) {
  return props.theme.typography.paragraph;
}, _linkBase.LinkBaseStyles, function (props) {
  return (0, _linkBase.linkVariants)(props)({
    variant: 'body'
  });
});
var _default = markdownStyles;
exports["default"] = _default;